module.exports = {
    expired_1: "링크 만료",
    limit_time: "한정 시간 오퍼 ",
    participate: "지금 바로 리뷰 이벤트에 참여하여 전용 보상을 받으세요!",
    exclusive: "전용",
    reward: "보상",
    token: "토큰",
    vip: "일 VIP",
    after_completing: "리뷰 및 스크린샷 인증 완료 후, 다음을 받게 됩니다",
    step_1: "<strong style='color: #000000'>아래 버튼을 클릭</strong>하여 앱 스토어를 방문하고 <strong style='color: #000000'>5성 리뷰를 남겨주세요.</strong>",
    step_2: "리뷰 완료 후, 리뷰 내용의 <strong style='color: #000000'>스크린샷을 찍어</strong> 주세요.",
    step_3: "아래에 <strong style='color: #000000'>스크린샷을 업로드</strong>하고 앱 내 ID를 제출하여 보상을 받으세요.",
    click_to: "1. 클릭하여 ",
    upload: "2. 리뷰 스크린샷 업로드",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "이동 ",
    example: "스크린샷 예시",
    upload_screenshot: "스크린샷 업로드",
    claim: "보상 받기",
    verification_inprogress: "업로드해 주셔서 감사합니다. 스크린샷을 최대한 빠르게 검토 중입니다. 잠시만 기다려 주세요.",
    verification_success: "축하합니다! <br/><br/> 보상을 성공적으로 받았습니다. 보상은 <strong>24시간 이내</strong>에 계정으로 지급됩니다. 기다려 주세요. <br/><br/> 궁금한 사항이 있으시면 고객 지원팀에 문의해 주세요.",
    verification_failed: "리뷰 스크린샷은 다음 조건을 충족해야 합니다: <br/><br/> <div style='margin-left: 6px'> 1.평점은 5점이어야 하며 내용은 긍정적이어야 합니다. <br/><br/> 2.리뷰는 <strong> Apple App Store 또는 Google Play Store </strong>에서 이루어져야 합니다. <br/><br/> 3.스크린샷에는 <strong> 아바타, 사용자 이름 및 리뷰 텍스트를 포함</strong>한 리뷰 내용이 완전히 표시되어야 합니다. <strong></div>",
    reupload: "다시 업로드"
}